import { Link } from "react-router-dom";
import { siteMeta } from "@/mocks/site";
import { specials } from "@/mocks/specials";

const stats = [
  { value: "12", label: "收录剧集" },
  { value: "6", label: "题材分类" },
  { value: "5", label: "编辑专题" },
  { value: "2026", label: "更新年度" },
];

export default function IntroSection() {
  return (
    <section className="border-t border-background-200 bg-background-100/70">
      <div className="container-page grid gap-10 py-14 md:grid-cols-12 md:py-20">
        <div className="md:col-span-7">
          <p className="rule-label text-accent-700">About the Archive</p>
          <h2 className="mt-3 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[30px]">
            我们把「伦理」当成一个可以被认真讨论的题目
          </h2>
          <p className="mt-4 text-sm leading-loose text-foreground-700">
            {siteMeta.description}
          </p>
          <p className="mt-3 text-sm leading-loose text-foreground-600">
            这里不追求推荐榜单，而是希望每一条目都能回答三个问题：它讨论了什么困境、它把镜头放在哪里、它为什么值得用两小时去看。所有条目由编辑部按题材归档，并附上一段编辑点评。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-900 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-800"
            >
              了解我们 <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/special/family-web"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-accent-400"
            >
              浏览专题
            </Link>
          </div>
        </div>

        <div className="md:col-span-5">
          <div className="grid grid-cols-2 gap-3">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="font-heading text-2xl font-semibold text-primary-900">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-3 rounded-lg border border-background-200 bg-background-50 p-4">
            <p className="rule-label text-foreground-500">专题速览</p>
            <ul className="mt-2 divide-y divide-background-200">
              {specials.slice(0, 3).map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/special/${item.id}`}
                    className="flex items-center justify-between gap-3 py-2.5 text-xs text-foreground-700 transition-colors hover:text-accent-700"
                  >
                    <span className="line-clamp-1">{item.title}</span>
                    <i className="ri-arrow-right-s-line shrink-0 text-foreground-400" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}